module.exports = __webpack_public_path__ + "img/menu-configuration.6d7468f5.svg";